import { ReactComponent as Logo } from './images/Notify_Logo.svg';

export default Logo;
